import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import Shell from "@/components/meridian/Shell";
import Home from "@/pages/Home";
import Workspace from "@/pages/Workspace";
import LendingHub from "@/pages/LendingHub";
import Settings from "@/pages/Settings";
import CreditReportsPage from "@/pages/CreditReports";
import { Navigate } from "react-router-dom";
import Executive from "@/pages/Executive";
import Grc from "@/pages/Grc";
import Presenter from "@/pages/Presenter";
import Admin from "@/pages/Admin";
import Policy from "@/pages/Policy";
import BatchIntake from "@/pages/BatchIntake";
import Approvals from "@/pages/Approvals";
import Systems from "@/pages/Systems";
import FraudEngine from "@/pages/FraudEngine";
import Monitor from "@/pages/Monitor";
import AmlIntel from "@/pages/AmlIntel";
import Governance from "@/pages/Governance";
import MarketComps from "@/pages/MarketComps";

function App() {
  return (
    <div>
      <BrowserRouter>
        <AppProvider>
          <Routes>
            <Route path="/presenter" element={<Presenter />} />
            <Route element={<Shell />}>
              <Route path="/" element={<Home />} />
              <Route path="/lending" element={<LendingHub />} />
              <Route path="/lending/batch" element={<BatchIntake />} />
              <Route path="/lending/batch/:batchId" element={<BatchIntake />} />
              <Route path="/policy" element={<Policy />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/audit" element={<Navigate to="/settings" replace />} />
              <Route path="/credit-reports" element={<CreditReportsPage />} />
              <Route path="/executive" element={<Executive />} />
              <Route path="/grc" element={<Grc />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/approvals" element={<Approvals />} />
              <Route path="/systems" element={<Systems />} />
              <Route path="/aml" element={<AmlIntel />} />
              <Route path="/fraud" element={<FraudEngine />} />
              <Route path="/monitor" element={<Monitor />} />
              <Route path="/governance" element={<Governance />} />
              <Route path="/market-comps" element={<MarketComps />} />
              <Route path="/market-comps/:id" element={<MarketComps />} />
              <Route path="/task/:id" element={<Workspace />} />
            </Route>
          </Routes>
          <Toaster theme="light" position="bottom-right" />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
